import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  ButtonM,
  ButtonXXS,
  Content,
  FlexBox,
  InputsDiv,
  Section,
  TextDiv,
} from "../styles/Common";
import { styled } from "styled-components";
import ImportentImg from "../styles/images/img_important_guide.png";
import PointBanner from "../components/pointChange/PointBanner";
import OnePageLayout from "../components/layout/OnePageLayout";
import { pointActions } from "../store/slices/pointSlice";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../components/hooks/authFunc";
import useDidMountEffect from "../components/hooks/useDidMountEffect";
import { Modal } from "../components/modal/Modal";
import {
  inputPriceFormat,
  replaceCommas,
  unComma,
} from "../components/hooks/basicFunc";

const PointChangePeerPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const target = location.state !== null ? location.state.target : "";
  const accessToken = getToken();
  const [openPointFailModal, setOpenPointFailModal] = useState(false);
  const [openPointChangeFailModal, setOpenPointChangeFailModal] =
    useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [changePoint, setChangePoint] = useState();
  const [btnDisabled, setBtnDisabled] = useState(true);
  const pointLookUpInfo = useSelector((state) => state.point.pointLookUpInfo);
  const modalMsg = useSelector((state) => state.point.modalMsg);
  const pointExchangeSuccess = useSelector(
    (state) => state.point.pointExchangeSuccess
  );

  const value1 = target.exEula;

  useEffect(() => {
    //포인트교환 페이지 진입 api 연동
    const params = {
      id: target.serviceId,
    };
    dispatch(pointActions.fetchPointLookUp({ params, accessToken }));
  }, []);

  const handleChangePoint = () => {
    const changedPoint = unComma(changePoint) / target.exchangeRate;
    const inputMinValue = target.exchangeRate * target.exchangeMin;
    if (target.exchangeMin > 0) {
      if (pointLookUpInfo.point < 0) {
        setOpenPointChangeFailModal(true);
      } else if (changedPoint > target.exchangeMax) {
        dispatch(
          pointActions.showMsg({
            msg: `1회 최대값을 초과하였습니다.`,
            type: "",
          })
        );
        return;
      } else if (unComma(changePoint) > pointLookUpInfo.point) {
        dispatch(
          pointActions.showMsg({
            msg: `보유포인트를 초과하였습니다.`,
            type: "",
          })
        );
        return;
      } else if (0 == target.exchangeCount) {
        dispatch(
          pointActions.showMsg({
            msg: `교환횟수를 초과하였습니다.`,
            type: "",
          })
        );
        return;
      } else if (changedPoint < target.exchangeMin) {
        dispatch(
          pointActions.showMsg({
            msg: `교환 최소 입력액은 ${inputMinValue} P 입니다.`,
            type: "",
          })
        );
        return;
      } else if (changedPoint > target.exchangeDay) {
        dispatch(
          pointActions.showMsg({
            msg: `1일 교환한도를 초과하였습니다.`,
            type: "",
          })
        );
        return;
      } else if (changedPoint > target.exchangeMonth) {
        dispatch(
          pointActions.showMsg({
            msg: `월 교환한도를 초과하였습니다.`,
            type: "",
          })
        );
        return;
      } else if (
        unComma(changePoint) % (target.exchangeUnit * target.exchangeRate) !==
        0
      ) {
        dispatch(
          pointActions.showMsg({
            msg: `유효하지 않는 발행 단위입니다. 최소교환가능  ${replaceCommas(
              target.exchangeMin * target.exchangeRate
            )}p에서 ${
              target.exchangeUnit * target.exchangeRate
            }의 배수로 입력해주세요.`,
            type: "",
          })
        );
        return;
      } else {
        const params = {
          id: target.serviceId,
          point: unComma(changePoint),
        };
        dispatch(pointActions.fetchPointExchange({ params, accessToken }));
      }
    } else {
      //한도체크 안함(최소액이 0일 경우)
      const params = {
        id: target.serviceId,
        point: unComma(changePoint),
      };
      dispatch(pointActions.fetchPointExchange({ params, accessToken }));
    }
  };

  useEffect(() => {
    // console.log(unComma(changePoint));
    if (unComma(changePoint) > 0) setBtnDisabled(true);
    else setBtnDisabled(false);
  }, [changePoint]);

  const convertToHtmlList = (text) => {
    const lines = text.split("\n");
    const listItems = lines.map((line, index) => (
      <li key={index}>{line.trim()}</li>
    ));

    return <ul>{listItems}</ul>;
  };
  useDidMountEffect(() => {
    if (pointExchangeSuccess)
      navigate("/point/change/result", {
        state: {
          target: pointLookUpInfo.serviceName,
          changePoint: unComma(changePoint),
          changedMup: changePoint / target.exchangeRate,
        },
      });
  }, [pointExchangeSuccess]);

  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);

  useDidMountEffect(() => {
    if (pointLookUpInfo.point == -1) {
      setOpenPointFailModal(true);
    }
    // else if (pointLookUpInfo.point >= 0) {
    //   //포인트 연동하기 api
    //   const params = {
    //     id: target.serviceId,
    //   };
    //   console.log("포인트 연동", params);
    //   dispatch(pointActions.fetchPointAffiliateLink({ params, accessToken }));
    // }
  }, [pointLookUpInfo]);

  const setMaxValue = () => {
    if (pointLookUpInfo.point > target.exchangeMax) {
      setChangePoint(target.exchangeMax);
    } else if (pointLookUpInfo.point < target.exchangeMax) {
      setChangePoint(pointLookUpInfo.point);
    } else {
      setChangePoint(0);
    }
  };

  return (
    <OnePageLayout title="포인트 교환">
      {openModal && (
        <Modal setOpenModal={setOpenModal}>
          <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
        </Modal>
      )}
      {openPointFailModal && (
        <Modal setOpenModal={setOpenPointFailModal} callbackFunc={() => {}}>
          <p>
            제휴서비스에 고객님의 정보를 <br />
            찾을 수 없습니다.
            <br />
            <br />
            제휴서비스에 가입하시고 다시 시도해주세요.
          </p>
        </Modal>
      )}
      {openPointChangeFailModal && (
        <Modal setOpenModal={setOpenPointChangeFailModal}>
          <p>
            포인트를 교환할 수 없습니다.
            <br />
            [보유 포인트 조회 실패]
          </p>
        </Modal>
      )}
      <PointChangeSection>
        <div>
          <PointBanner mup={pointLookUpInfo.mup} />
          <PointChangeContent>
            <PointChangeTextDiv>
              <h3>
                {pointLookUpInfo.serviceName} 보유 포인트{" "}
                <span className="col">
                  {" "}
                  {pointLookUpInfo.point < 0
                    ? "0"
                    : replaceCommas(pointLookUpInfo.point)}{" "}
                  P
                </span>
              </h3>
            </PointChangeTextDiv>
            <PointChangeInputsDiv>
              <div>
                <input
                  onChange={(e) => {
                    setChangePoint(e.target.value);
                  }}
                  value={
                    changePoint == -1 ? 0 : inputPriceFormat(changePoint) || ""
                  }
                  type="text"
                  placeholder="교환할 포인트를 입력해주세요."
                />
                <ButtonXXS
                  onClick={() => {
                    setChangePoint(pointLookUpInfo.point);
                    // setMaxValue();
                  }}
                >
                  최대
                </ButtonXXS>
              </div>
              {target.exchangeMin > 0 ? (
                <p>
                  발행단위{" "}
                  {replaceCommas(target.exchangeUnit * target.exchangeRate)}p /
                  1회 최대{" "}
                  {replaceCommas(target.exchangeMax * target.exchangeRate)}p /
                  최소 {replaceCommas(target.exchangeMin * target.exchangeRate)}
                  p 교환 가능
                </p>
              ) : (
                <></>
              )}
            </PointChangeInputsDiv>
          </PointChangeContent>
        </div>
        <Btns>
          <ImportantGuide>
            <div>
              <img src={`${ImportentImg}`} alt="" />
            </div>
            {convertToHtmlList(value1)}
            {/* <ul>
              <li> · 포인트는 전환 비율에 따라 교환 됩니다.</li>
              <li> · 교환된 뮤포인트는 바로 사용 가능합니다.</li>
              <li> · 교환된 포인트는 이전 포인트로 전환할수 없습니다.</li>
              <li> · 교환된 포인트는 뮤포인트 이용정책을 따릅니다.</li>
              <li> · 제휴사의 교환비율은 제휴사에 따라 상이합니다.</li>
              <li> · 교환수수료가 반영이 되지 않은 가격입니다.</li>
            </ul> */}
          </ImportantGuide>
          <ButtonL
            disabled={!btnDisabled}
            onClick={() => {
              handleChangePoint();
            }}
          >
            교환하기
          </ButtonL>
        </Btns>
      </PointChangeSection>
    </OnePageLayout>
  );
};

export default PointChangePeerPage;

const PointChangeSection = styled(Section)`
  padding-top: 0;
`;

const PointChangeContent = styled(Content)`
  /* padding: 0; */
`;

const PointChangeTextDiv = styled(TextDiv)`
  margin-top: 4rem;
  h3 {
    letter-spacing: -0.48px;
    span {
      margin-left: 0.6rem;
      font-family: NanumSquareEB;
    }
  }
  p {
    letter-spacing: -0.42px;
    margin-top: 1.5rem;
  }
`;

const PointChangeInputsDiv = styled(InputsDiv)`
  margin-top: 4rem;
  & > div {
    display: flex;
    align-items: end;
  }

  input {
    width: calc(100% - 8rem);
    margin-right: 2rem;
  }
  p {
    color: ${({ theme }) => theme.color.purple_secondary};
    margin-top: 1rem;
    font-family: NanumSquareB;
    font-size: 1.2rem;
    line-height: 1.2rem; /* 100% */
    letter-spacing: -0.36px;
  }
`;

const ImportantGuide = styled(FlexBox)`
  padding-bottom: 3rem;
  align-items: flex-start;
  justify-content: center;
  img {
    width: 5.4rem;
    margin-right: 1rem;
  }
  ul {
    margin-top: 4.1rem;
    width: calc(100% - 8.4rem);
  }
  li {
    text-align: left;
    color: ${({ theme }) => theme.color.purple_dark};
    font-size: 1.2rem;
    line-height: 2rem; /* 166.667% */
    letter-spacing: -0.36px;
  }
`;
